import type { AvailableSlotsQueryDTO } from "../../api/available-slots/available-slots.types";
import type { ParticipantWithId, TimeIntervals } from "../../types/general";

export const initialAppointmentData = {
  date: "",
  timeRange: [],
};

// Data of the person who's booking the event
export const BOOKER_CONTACT_DATA: ParticipantWithId = {
  id: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  gender: "",
};

// main contact form initial values
export const CONTACT_FORM_INITIAL_VALUES = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  gender: {
    label: "",
    value: "",
  },
  customFields: [] as string[],
  message: "",
};

export const userAppointmentData: AvailableSlotsQueryDTO = {} as AvailableSlotsQueryDTO;

export const initialTimeIntervals: TimeIntervals = {
  "0000-00-00": {
    intervals: [
      {
        from: "00:00",
        to: "00:00",
      },
    ],
  },
};
